import Utils from "../Utils";
import store from "../store";
import dayjs from "dayjs";
import split from "lodash/split";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import chunk from "lodash/chunk";
import orderBy from "lodash/orderBy";

function getNewsTutorialFullList() {
  const now = new Date();
  return new Promise((resolve, reject) => {
    try {
      setTimeout(() => {
        let newsTuturoialObj = {
          newsTutorialList: [],
          numberOfNews: 0
        };
        newsTuturoialObj.newsTutorialList = [
          {
            id: "1",
            type: "video-tutorials",
            status: "New",
            title: "News 1",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: true
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit."
          },
          {
            id: "2",
            type: "newsletter",
            status: "To read",
            title: "News 2",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "3",
            type: "rules",
            status: "To read",
            title: "News 3",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: true
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "4",
            type: "manuals",
            status: "New",
            title: "News 4",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "5",
            type: "news-hf",
            status: "New",
            title: "News 5",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "6",
            type: "news-hf",
            status: "New",
            title: "News 6",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "7",
            type: "manuals",
            status: "New",
            title: "News 7",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "81",
            type: "newsletter",
            status: "To read",
            title: "News 81",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          },
          {
            id: "90",
            type: "newsletter",
            status: "To read",
            title: "News 90",
            date: Utils.randomDate(new Date(2019, 0, 1), now),
            feedback: {
              required: false
            },
            description:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis quidem officia iusto deserunt sint exercitationem deleniti voluptatem eum dolorem debitis."
          }
        ];

        newsTuturoialObj.numberOfNews =
          newsTuturoialObj.newsTutorialList.length;

        resolve(newsTuturoialObj);
      }, 2000);
    } catch (error) {
      reject(error);
    }
  });
}

function inSearch(newsTutorial, toSearch) {
  let newsTutorialList = newsTutorial.newsTutorialList.filter(item => {
    const itemTitle = item.title;
    const queryRegexPattern =
      !toSearch || toSearch.trim() == "" ? "." : toSearch;
    const regex = new RegExp(queryRegexPattern, "i");
    return itemTitle.search(regex) != -1;
  });

  return {
    newsTutorialList,
    numberOfNews: newsTutorialList.length
  };
}

function inFilter(newsTutorial, toFilter) {
  let filterArray = split(toFilter, ",");

  if (!isEmpty(filterArray) && filterArray[0] !== "") {
    let newsTutorialList = filter(
      newsTutorial.newsTutorialList,
      newsTutorial => {
        return includes(filterArray, newsTutorial.type);
      }
    );

    return {
      newsTutorialList,
      numberOfNews: newsTutorialList.length
    };
  } else {
    return newsTutorial;
  }
}

function inDateRange(newsTutorial, dateFrom, dateTo) {
  const format = "YYYY-MM-DD";
  let formatDateFrom = dayjs(dateFrom).format(format);
  let formatDateTo = dayjs(dateTo).format(format);

  let newsTutorialList = newsTutorial.newsTutorialList.filter(newsTutorial => {
    if (formatDateFrom && formatDateTo) {
      const newsTutorialDate = dayjs(newsTutorial.date).format(format);
      return (
        dayjs(newsTutorialDate).isBetween(formatDateFrom, formatDateTo) ||
        dayjs(newsTutorialDate).isSame(formatDateFrom)
      );
    } else {
      return true;
    }
  });
  return {
    newsTutorialList,
    numberOfNews: newsTutorialList.length
  };
}

function inPagination(billObj, page, size = 4) {
  if (isEmpty(billObj)) {
    return {
      newsTutorialList: [],
      numberOfNews: 0
    };
  } else {
    let splitList = chunk(billObj.newsTutorialList, size);
    if (Math.ceil(billObj.numberOfNews / size) >= page) {
      return {
        newsTutorialList: splitList[page - 1],
        numberOfNews: billObj.numberOfNews
      };
    } else {
      return {
        newsTutorialList: splitList[0],
        numberOfNews: billObj.numberOfNews
      };
    }
  }
}

function inOrder(newsTutorial, order) {
  const sortBy = order == "A-Z" ? "asc" : "desc";

  let orderedList = orderBy(newsTutorial.newsTutorialList, "title", sortBy);

  return {
    newsTutorialList: orderedList,
    numberOfNews: orderedList.length
  };
}

export default class NewsTutorialService {
  constructor() {
    this.networkDelay = 2000;
  }
  fetchNewsTutorial(parameters) {
    const LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
    store.commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
      root: true
    });
    return getNewsTutorialFullList()
      .then(newsTutorial => {
        return inSearch(newsTutorial, parameters.toSearch);
      })
      .then(newsTutorial => {
        return inFilter(newsTutorial, parameters.toFilter);
      })
      .then(newsTutorial => {
        if (
          (parameters.dateFrom || parameters.dateTo) &&
          newsTutorial.numberOfNews
        )
          return inDateRange(
            newsTutorial,
            parameters.dateFrom,
            parameters.dateTo
          );
        else return newsTutorial;
      })
      .then(newsTutorial => {
        if (parameters.order && newsTutorial.numberOfNews)
          return inOrder(newsTutorial, parameters.order);
        else return newsTutorial;
      })
      .then(newsTutorial => {
        if (parameters.page && newsTutorial.numberOfNews)
          return inPagination(newsTutorial, parameters.page, parameters.size);
        else return newsTutorial;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        store.commit("loading/CLOSE_LOADING_DIALOG", {
          root: true
        });
      });
  }
}
